import i18n from "./index";
import { resolveLocale } from "./locales";

/**
 * Tells the API which language to answer in. It translates error messages
 * (nestjs-i18n on api.maihrms.com) and falls back to English without it.
 *
 * `x-lang` rather than `Accept-Language`: the browser already sends its own
 * Accept-Language, which reflects the OS rather than the language picked in
 * the app — and the API also reads that header to guess a timezone.
 */
export const LANGUAGE_HEADER = "x-lang";

export const requestLanguage = () => resolveLocale(i18n.language).code;

/** Spread into a `fetch` call's `headers` object. */
export const languageHeader = () => ({ [LANGUAGE_HEADER]: requestLanguage() });
